import React, { createContext, useContext, useState, useEffect } from 'react';
import clientApi from '../lib/clientApi';

const ClientAuthContext = createContext(null);

export const ClientAuthProvider = ({ children }) => {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('dts_client_token');
    if (token) {
      clientApi.get('/clients/me')
        .then((res) => setClient(res.data))
        .catch(() => localStorage.removeItem('dts_client_token'))
        .finally(() => setLoading(false));
    } else { setLoading(false); }
  }, []);

  const login = async (email, password) => {
    const res = await clientApi.post('/clients/login', { email, password });
    localStorage.setItem('dts_client_token', res.data.token);
    setClient(res.data.client);
    return res.data.client;
  };

  const register = async (payload) => {
    const res = await clientApi.post('/clients/register', payload);
    localStorage.setItem('dts_client_token', res.data.token);
    setClient(res.data.client);
    return res.data.client;
  };

  const logout = () => { localStorage.removeItem('dts_client_token'); setClient(null); };

  return (
    <ClientAuthContext.Provider value={{ client, loading, login, register, logout }}>
      {children}
    </ClientAuthContext.Provider>
  );
};

export const useClientAuth = () => useContext(ClientAuthContext);
